import { format } from "date-fns"
import React from "react"

function classNames(...classes) {return classes.filter(Boolean).join(' ')}
const WeekViewEventChip = ({event, openEvent, setOpenEvent, selectedDay}) => {
  
    const [eventColumn, setEventColumn] = React.useState(`sm:col-start-${event.index} col-start-1`)
    const [size, setSize] = React.useState([0, 0]);

    React.useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);

    React.useEffect(() => {
      size[0] > 640 ? setEventColumn(`col-start-${event.index}`) : setEventColumn('col-start-1')
    }, [size])

    return (
      <li key={event.id} onClick={() => setOpenEvent(event)} className={classNames(event.isPendingOffer && `animate-pulse`, `relative cursor-pointer flex`, (format(selectedDay.date, 'EEEE') === format(new Date(event.dateTime), 'EEEE')) ? eventColumn : `col-start-${event.index}`)} style={{ gridRow: `${event.rowNumber}/ ${event.rowNumber + event.rowLength}`, zIndex: event.isAvailabilityPlaceholder ? 0 : `${event.rowNumber/10}`}}>
        <div
          className={classNames(
            (event.isAvailabilityPlaceholder || event.isPendingOffer) && `border-solid border-2 ${event.color.borderColor200}`, 
            event.isPendingOffer && 'bg-gray-200 border-black text-white',
            !event.isAvailabilityPlaceholder && !event.isPendingOffer && `${event.isIntro ? 'bg-amber-100' : event.color.bgColor200}` ,`group absolute -mt-[1px] inset-x-1 inset-y-0 inset flex flex-col -z-0 overflow-y-auto rounded-lg px-1 text-xs transition-shadow duration-300 border-solid border-2 ${event.color.borderColor500} hover:shadow-xl leading-5 hover:${event.color.textColor800}`)}
        >
          {event.isPendingOffer && <p className='m-0 text-red-600 text-xs border-2 border-red-600 border-solid text-center rounded-md'>PENDING OFFER</p>}
          <p className={`font-bold text-[12px] m-1 p-0 text-left leading-3 ${event.color.textColor800}`}>{event.name}</p>
          <p className={`${event.color.textColor500} m-0 block -mt-1 p-0 ml-1 text-[10px] w-full text-left`}>
            <time dateTime={event.dateTime}>{event.time}</time>
          </p>
          {!event.isAvailabilityPlaceholder && <p className={`block text-[10px] w-full ${event.color.textColor500} text-left -mt-2 ml-1 m-0`}>{event.lessonLength} min</p>}
        </div>
      </li>
    )
}
export default WeekViewEventChip